import { LicenseDetailsModel } from './license-details.model';
import { LicenseProductDetailsModel } from './license-product-detail.model';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import {
  Component, Input, Output, EventEmitter, OnInit, ElementRef, HostListener, forwardRef,
  ViewEncapsulation, ViewChild
} from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UserWizardService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { UserWizardModel } from 'lib/ng2-sapmp/src/models';

declare var ENV_PORTAL: any;
const ENV_PORTAL_DOMAIN: any = (ENV_PORTAL === 'fnabc') ? 'FN' : 'ABC';

@Component({
  selector: 'app-manage-licenses-card',
  styleUrls: ['./licenses-card.component.scss'],
  templateUrl: './licenses-card.component.html',
  encapsulation: ViewEncapsulation.Emulated
})
// [Anand] renamed class name and folder as per standards
export class LicensesCardComponent implements OnInit {

  assignProductFlag: boolean;
  editNameFlag: boolean;
  licenseFlag: boolean;
  modalClass: string;
  licenseForm: FormGroup;
  assignUnassign: string;
  userWizardModel: UserWizardModel;
  focusabbleElements: any;
  csrPermissionLicenseCardAssignButton: boolean;
  modalCoverClass = 'scrollcontent';
  productPortal = false;
  @Input() singlelicense: LicenseDetailsModel;
  @Output() reviewComponentSuccessMessageFlagValue: EventEmitter<Boolean>;
  @Output() showEditAssignModelPopUp: EventEmitter<any>;
  @ViewChild('assign') assignElement;

  leftLabel = 'Licenses assigned';
  rightLabel = '';

  constructor(private el: ElementRef, private formBuilder: FormBuilder,
    private userWizardService: UserWizardService, private router: Router,
    private utilityService: UtilityService) {
    this.assignUnassign = 'manage.assignunassign';
    this.reviewComponentSuccessMessageFlagValue = new EventEmitter<Boolean>();
    this.showEditAssignModelPopUp = new EventEmitter<any>();
    this.userWizardModel = new UserWizardModel();
    this.userWizardService.removeAssignOrUnassignWizard();
    this.csrPermissionLicenseCardAssignButton = this.utilityService.checkFieldPermission('licenseCard.assign',
      JSON.parse(sessionStorage.getItem('permissions')).perm);
    this.assignProductFlag = false;
    this.editNameFlag = false;
    this.licenseFlag = false;
  }


  ngOnInit() {
    if ( this.singlelicense.fanType !== ENV_PORTAL_DOMAIN ) {
      this.productPortal = true;

    }
    sessionStorage.removeItem('singleUserDetail');
  }

  editAssignName(updateName, event) {
    this.licenseFlag = true;
    if (updateName === 'assign') {
      this.assignProductFlag = true;
    } else if (updateName === 'edit') {
      this.editNameFlag = true;
      this.reviewComponentSuccessMessageFlagValue.emit(false);
    }
    const popupObject = {
      'editNameFlag': this.editNameFlag,
      'assignProductFlag': this.assignProductFlag,
      'licenseFlag': this.licenseFlag,
      'singlelicense': this.singlelicense,
      'formEventEmitter': event
    };
    this.showEditAssignModelPopUp.emit(popupObject);
  }

  assignUnassignWizard(ctn) {
    this.userWizardModel.product = {};
    this.userWizardModel.source = 'product';
    this.userWizardModel.product.productName = this.singlelicense.specName;
    this.userWizardModel.product.dcmCode = this.singlelicense.serviceOfferCode;
    this.userWizardModel.product.fan = this.singlelicense.brokerAccountClientId;
    this.userWizardModel.product.ctn = this.singlelicense.billingClientId;
    this.userWizardModel.product.clientId = this.singlelicense.clientId;
    this.userWizardModel.product.licensegroupName = this.singlelicense.productDesc;
    this.userWizardModel.product.totalLicensesAvailable = this.singlelicense.quantity - this.singlelicense.totalLicensesInUse;
    this.userWizardModel.product.totalLicensesInUse = this.singlelicense.totalLicensesInUse;
    this.userWizardModel.previousUrl = this.router.url;
    this.userWizardService.addAssignOrUnassignWizard(this.userWizardModel);
    this.router.navigate(['/manageUsers']);
  }

  setDataToManageProduct(event) {
    if (sessionStorage.getItem('singleUserDetail') !== undefined) {
      sessionStorage.removeItem('singleUserDetail');
    }
    sessionStorage.setItem('singleUserDetail', JSON.stringify(this.singlelicense));
    this.router.navigate(['/manageProduct']);
  }

}
